import React from "react";
import { useState, useEffect } from "react";
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Box, Paper, Typography, TextField, Button, CircularProgress, Tooltip, Toolbar, IconButton, List } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CreateIcon from "@mui/icons-material/Create";
import {
  ApiGet,
  ApiPost,
  ApiPut,
  ApiDelete,
} from "../helpers/API/ApiData";
import DeleteIcon from "@mui/icons-material/Delete";
import { toast, ToastContainer } from "react-toastify";
import { DataTable, TableColumnDef } from "../components/DataTable";
import { TableThumbnail } from "../components/TableThumbnail";
import { usePermissions } from "../hooks/usePermissions";
import { useImageCrop, useContentLanguage } from "../hooks";
import { LanguageTabs } from "../components/LanguageTabs";
import { PageHeader } from "../components/PageHeader";
import { ImageCropField } from "../components/ImageCropField";

export default function Servicecategory() {
  const { canCreate, canEdit, canDelete } = usePermissions("/service-category");
  const [Servicecategory, setServicecategory] = useState<any>() as any;
  const [addCategory, setAddCategory] = useState(false);
  const [errors, setErrors] = useState<any>({});
  const [getAllCategory, setGetAllCategory] = useState<any[]>([]);
  const [isEditApi, setIsEditApi] = useState(false);
  const [search, setSearch] = useState<any>();
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(0);
  const [categoryIdForEdit, setCategoryIdForEdit] = useState<any>();
  const [categoryIdForDelete, setCategoryIdForDelete] = useState<any>();
  const [countPerPage, setCountPerPage] = useState(10);
  const [loader, setLoader] = useState(false);
  const [loaderForGetAll, setLoaderForGetAll] = useState(false);
  const [show, setShow] = useState(false);

  const [lang, setLang] = useContentLanguage();

  const imageCropEn = useImageCrop();
  const imageCropGer = useImageCrop();
  const [removeCategoryImage, setRemoveCategoryImage] = useState(false);
  const [removeCategoryImageGer, setRemoveCategoryImageGer] = useState(false);

  useEffect(() => {
    getAllCategoryData();
  }, [page, countPerPage, search]);

  const addDocumentModelClose = () => {
    setAddCategory(false);
    setIsEditApi(false);
    setErrors({});
    setServicecategory({});
    imageCropEn.reset();
    imageCropGer.reset();
    setRemoveCategoryImage(false);
    setRemoveCategoryImageGer(false);
  };

  const onhandleChange = (e: any) => {
    const { name, value } = e.target;
    setServicecategory({ ...Servicecategory, [name]: value });
    setErrors({ ...errors, [name]: "" });
  };

  const formValidation = () => {
    let formIsValid = true;
    const err: any = {};
    if (
      !Servicecategory?.categoryName?.trim() ||
      Servicecategory?.categoryName === ""
    ) {
      formIsValid = false;
      err["categoryName"] = "*Bitte geben Sie den Kategorienamen ein";
    }
    if (
      !Servicecategory?.categoryName_ger?.trim() ||
      !Servicecategory?.categoryName_ger
    ) {
      formIsValid = false;
      err["categoryName_ger"] = "*Bitte geben Sie den Kategorienamen ein";
    }
    if (!imageCropEn.imageToUpload && !Servicecategory?.categoryImage) {
      formIsValid = false;
      err["categoryImage"] = "*Bitte wählen Sie ein Bild aus";
    }
    if (!imageCropGer.imageToUpload && !Servicecategory?.categoryImage_ger) {
      formIsValid = false;
      err["categoryImage_ger"] = "*Bitte wählen Sie ein Bild aus";
    }
    setErrors(err);
    return formIsValid;
  };

  const handleClose = () => {
    setShow(false);
  };

  const getAllCategoryData = async () => {
    setLoaderForGetAll(true);
    const params = `page=${page}&limit=${countPerPage}${search ? `&letter=${search}` : ""}`;
    await ApiGet(`service/find?${params}`)
      .then((res: any) => {
        setGetAllCategory(res?.data?.data);
        setCount(res?.data?.count ?? 0);
        setLoaderForGetAll(false);
      })
      .catch(() => {
        setLoaderForGetAll(false);
      });
  };

  const addCategoryData = async () => {
    setIsEditApi(false);
    if (formValidation()) {
      setLoader(true);
      try {
        const formData = new FormData();
        formData.append("categoryName", Servicecategory?.categoryName);
        formData.append("categoryName_ger", Servicecategory?.categoryName_ger);

        const croppedEn = await imageCropEn.getCroppedFile();
        if (croppedEn) formData.append("categoryImage", croppedEn);
        const croppedGer = await imageCropGer.getCroppedFile();
        if (croppedGer) formData.append("categoryImage_ger", croppedGer);

        await ApiPost(`service/create`, formData);
        toast.success("Erfolgreich hinzufügen");
        setAddCategory(false);
        setIsEditApi(false);
        getAllCategoryData();
        setServicecategory({});
        imageCropEn.reset();
        imageCropGer.reset();
      } catch (err: any) {
        toast.error(err?.response?.data?.message || "Etwas ist schief gelaufen...");
      } finally {
        setLoader(false);
      }
    }
  };

  const EditCategoryData = async () => {
    if (formValidation()) {
      setLoader(true);
      try {
        const formData = new FormData();
        formData.append("categoryName", Servicecategory?.categoryName);
        formData.append("categoryName_ger", Servicecategory?.categoryName_ger);

        const croppedEn = await imageCropEn.getCroppedFile();
        if (croppedEn) formData.append("categoryImage", croppedEn);
        const croppedGer = await imageCropGer.getCroppedFile();
        if (croppedGer) formData.append("categoryImage_ger", croppedGer);
        if (removeCategoryImage) formData.append("removeCategoryImage", "true");
        if (removeCategoryImageGer) formData.append("removeCategoryImage_ger", "true");

        await ApiPut(`service/update?id=${categoryIdForEdit}`, formData);
        toast.success("Erfolgreich geupdated");
        getAllCategoryData();
        setAddCategory(false);
        setIsEditApi(false);
        setServicecategory({});
        imageCropEn.reset();
        imageCropGer.reset();
        setRemoveCategoryImage(false);
        setRemoveCategoryImageGer(false);
      } catch (err: any) {
        toast.error(err?.response?.data?.message || "Etwas ist schief gelaufen...");
      } finally {
        setLoader(false);
      }
    }
  };

  const DeleteCategoryData = async () => {
    await ApiDelete(`service/delete?id=${categoryIdForDelete}`)
      .then((res: any) => {
        if (res?.status === 200) {
          toast.success("Erfolgreich löschen");
          setShow(false);
          setPage(1);
          getAllCategoryData();
        } else {
          toast.error(res?.data?.message || "Etwas ist schief gelaufen...");
        }
      })
      .catch((err: any) => {
        toast.error(err?.response?.data?.message || "Etwas ist schief gelaufen...");
      });
  };

  const columns: TableColumnDef[] = [
    {
      header: "Kategoriename",
      render: (row: any) => (lang === "de" ? row?.categoryName_ger : row?.categoryName) || "-",
      getValue: (row: any) => (lang === "de" ? row?.categoryName_ger : row?.categoryName) || "-",
    },
    {
      header: "Bild",
      render: (row: any) => (
        <TableThumbnail src={lang === "de" ? row?.categoryImage_ger : row?.categoryImage} />
      ),
    },
    {
      header: "Einstellungen",
      render: (row: any) => (
        <Box sx={{ display: "flex", gap: 0.5 }}>
          {canEdit && (
            <Tooltip title="Dokument bearbeiten" arrow>
              <IconButton
                size="small"
                color="primary"
                onClick={() => {
                  setIsEditApi(true);
                  setAddCategory(true);
                  setCategoryIdForEdit(row?._id);
                  setServicecategory({
                    categoryName: row?.categoryName,
                    categoryName_ger: row?.categoryName_ger,
                    categoryImage: row?.categoryImage,
                    categoryImage_ger: row?.categoryImage_ger,
                  });
                  imageCropEn.reset();
                  imageCropGer.reset();
                }}
              >
                <CreateIcon />
              </IconButton>
            </Tooltip>
          )}
          {canDelete && (
            <Tooltip title="Dokument löschen" arrow>
              <IconButton
                size="small"
                color="error"
                onClick={() => {
                  setCategoryIdForDelete(row?._id);
                  setShow(true);
                }}
              >
                <DeleteIcon />
              </IconButton>
            </Tooltip>
          )}
        </Box>
      ),
    },
  ];

  return (
    <>
      <Paper sx={{ p: 1 }}>
        <ToastContainer />
        <PageHeader
          title="Concierge service"
          onSearch={(val) => { setSearch(val); setPage(1); }}
          onAdd={canCreate ? () => {
            setIsEditApi(false);
            setServicecategory({});
            setErrors({});
            imageCropEn.reset();
            imageCropGer.reset();
            setAddCategory(true);
          } : undefined}
        />
        <LanguageTabs value={lang} onChange={setLang} />
        {loaderForGetAll ? (
          <Box sx={{ display: "flex", justifyContent: "center", mt: 2.5 }}>
            <CircularProgress />
          </Box>
        ) : (
          <DataTable
            rows={getAllCategory || []}
            columns={columns}
            page={page}
            count={count}
            rowsPerPage={countPerPage}
            onPageChange={setPage}
            onRowsPerPageChange={setCountPerPage}
          />
        )}
      </Paper>
      <Dialog open={show} onClose={handleClose}>
        <DialogTitle sx={{ color: "error.main", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          Löschen bestätigen
          <IconButton size="small" onClick={handleClose} aria-label="close">
            <CloseIcon fontSize="small" />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            Möchten Sie diese Kategorie wirklich löschen?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="inherit">
            Nein
          </Button>
          <Button onClick={() => DeleteCategoryData()} color="error" variant="contained">
            Ja
          </Button>
        </DialogActions>
      </Dialog>

      {addCategory === true ? (
        <Dialog fullScreen open={addCategory}>
          <Toolbar>
            <IconButton
              edge="end"
              color="inherit"
              onClick={() => addDocumentModelClose()}
              aria-label="close"
              sx={{ ml: "auto" }}
            >
              <CloseIcon />
            </IconButton>
          </Toolbar>
          <List>
            <Box sx={{ maxWidth: 1200, mx: "auto", p: 3 }}>
              <Box sx={{ display: "flex", mb: 3, flexWrap: "wrap" }}>
                <Box sx={{ width: { xs: "100%", lg: "16.66%" } }} />
                <Box sx={{ width: { xs: "100%", lg: "41.67%" }, textAlign: "center" }}>
                  <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 1 }}>
                    Deutsch
                  </Typography>
                </Box>
                <Box sx={{ width: { xs: "100%", lg: "41.67%" }, textAlign: "center" }}>
                  <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 1 }}>
                    English
                  </Typography>
                </Box>
              </Box>

              <Box sx={{ display: "flex", mb: 3, flexWrap: "wrap" }}>
                <Typography sx={{ width: { xs: "100%", lg: "16.66%" }, pt: 1 }}>
                  Kategoriename
                </Typography>
                <Box sx={{ width: { xs: "100%", lg: "41.67%" }, pr: 1 }}>
                  <TextField
                    size="small"
                    fullWidth
                    variant="outlined"
                    id="categoryName_ger"
                    name="categoryName_ger"
                    value={Servicecategory?.categoryName_ger}
                    onChange={(e) => onhandleChange(e)}
                  />
                  <Typography variant="caption" color="error">
                    {errors["categoryName_ger"]}
                  </Typography>
                </Box>
                <Box sx={{ width: { xs: "100%", lg: "41.67%" }, pr: 1 }}>
                  <TextField
                    size="small"
                    fullWidth
                    variant="outlined"
                    id="categoryName"
                    name="categoryName"
                    value={Servicecategory?.categoryName}
                    onChange={(e) => onhandleChange(e)}
                  />
                  <Typography variant="caption" color="error">
                    {errors["categoryName"]}
                  </Typography>
                </Box>
              </Box>

              <Box sx={{ display: "flex", mb: 3, flexWrap: "wrap" }}>
                <Typography sx={{ width: { xs: "100%", lg: "16.66%" }, pt: 1 }}>
                  Bild
                </Typography>
                <Box sx={{ width: { xs: "100%", lg: "41.67%" }, pr: 1 }}>
                  <ImageCropField
                    inputId="categoryImage_ger"
                    imageCrop={imageCropGer}
                    existingImage={Servicecategory?.categoryImage_ger}
                    error={errors["categoryImage_ger"]}
                    onRemoveExistingImage={() => {
                      setServicecategory({ ...Servicecategory, categoryImage_ger: "" });
                      setRemoveCategoryImageGer(true);
                    }}
                  />
                </Box>
                <Box sx={{ width: { xs: "100%", lg: "41.67%" }, pr: 1 }}>
                  <ImageCropField
                    inputId="imageUpload"
                    imageCrop={imageCropEn}
                    existingImage={Servicecategory?.categoryImage}
                    error={errors["categoryImage"]}
                    onRemoveExistingImage={() => {
                      setServicecategory({ ...Servicecategory, categoryImage: "" });
                      setRemoveCategoryImage(true);
                    }}
                  />
                </Box>
              </Box>
            </Box>

            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <Button
                variant="contained"
                disabled={loader}
                onClick={() => {
                  isEditApi ? EditCategoryData() : addCategoryData();
                }}
              >
                {isEditApi ? "Speichern" : "Hinzufügen"}
                {loader && <CircularProgress size={20} sx={{ ml: 1 }} />}
              </Button>
            </Box>
          </List>
        </Dialog>
      ) : null}
    </>
  );
}
